module.exports = __webpack_public_path__ + "static/img/32.9c14ce22.png";